/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import UiStepsNavItems from './UiStepsNavItems'

export type UiStepsNavStep<StepId extends number> = {
    id: StepId
    label: string
}

export type UiStepsNavProps<StepId extends number> = {
    activeStep: StepId
    maxReachedStep: StepId
    onChange: (step: StepId) => void
    steps: UiStepsNavStep<StepId>[]
}

const UiStepsNav = <StepId extends number>({
    activeStep,
    maxReachedStep,
    onChange,
    steps,
}: UiStepsNavProps<StepId>) => {
    const handleSelect = (stepId: StepId) => {
        if (stepId <= maxReachedStep) {
            onChange(stepId)
        }
    }

    return (
        <div
            className={clsx(
                'UiStepsNav w-full flex items-center gap-2 px-2 py-2 text-xs font-medium text-gray-500 dark:text-gray-400'
            )}
        >
            <UiStepsNavItems
                steps={steps}
                activeStep={activeStep}
                maxReachedStep={maxReachedStep}
                onSelect={handleSelect}
            />
        </div>
    )
}

export default UiStepsNav
